import React from 'react'
import User from '../../../images/icons/user.svg'

const UserIcon = () => <User/>

export default UserIcon